export enum EVENTS {
  ElementClicked = "redventures.usertracking.v3.ElementClicked",
  ElementViewed = "redventures.usertracking.v3.ElementViewed",
  ProductClicked = "redventures.ecommerce.v1.ProductClicked",
  ProductViewed = "redventures.ecommerce.v1.ProductViewed",
  ProductLoaded = "redventures.ecommerce.v1.ProductLoaded",
  ConversionTracked = "core.conversions.ConversionTracked.v2",
}
